(() => {
  const syncMobileNavigation = () => {
    document.querySelectorAll('mobile-navigation-bar.mobile-navigation-bar').forEach((nav) => {
      const path = window.location.pathname.replace(/\/+$/, '') || '/';
      const links = Array.from(nav.querySelectorAll(':scope > a'));

      links.forEach((link) => {
        link.classList.remove('active');
        link.removeAttribute('aria-current');
      });

      let activeLink = null;
      if (path === '/') {
        activeLink = nav.querySelector('#homepage-icon-bubble');
      } else if (path === '/cart' || path.startsWith('/cart/')) {
        activeLink = nav.querySelector('#cart-icon-bubble-mobile');
      } else if (path.startsWith('/account') || path.startsWith('/customer_authentication')) {
        activeLink = links.find((link) => /account|customer_authentication/.test(link.getAttribute('href') || ''));
      } else if (/^\/(collections|products|search)(\/|$)/.test(path)) {
        activeLink = nav.querySelector('#shop-icon-bubble-mobile') || links.find((link) => (link.getAttribute('href') || '') === '/collections');
      }

      if (activeLink) {
        activeLink.classList.add('active');
        activeLink.setAttribute('aria-current', 'page');
      }

      nav.querySelectorAll('.cart-count, .wishlist-count').forEach((badge) => {
        const count = (badge.childNodes[0]?.textContent || badge.textContent || '').trim();
        badge.classList.toggle('is-zero', count === '0');
      });
    });
  };

  const mobileMedia = window.matchMedia('(max-width: 768px)');
  const isProductPage = () => /^\/products\//.test(window.location.pathname);
  let lastScrollY = Math.max(0, window.scrollY);
  let scrollTicking = false;
  let snugNavHoldVisibleUntil = 0;

  const setNavigationHidden = (hidden) => {
    document.querySelectorAll('mobile-navigation-bar.mobile-navigation-bar').forEach((nav) => {
      nav.classList.toggle('snug-nav-hidden', hidden);
      nav.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    });
    document.querySelectorAll('shopify-chat').forEach((chat) => {
      chat.classList.toggle('snug-nav-hidden', hidden);
    });
  };

  const syncScrollVisibility = () => {
    scrollTicking = false;
    const currentY = Math.max(0, window.scrollY);
    const delta = currentY - lastScrollY;
    const root = document.documentElement;
    const overlayOpen = root.classList.contains('open-minicart')
      || root.classList.contains('open-drawer')
      || root.classList.contains('snug-search-open')
      || root.classList.contains('snug-menu-open');

    const holdVisible = Date.now() < snugNavHoldVisibleUntil;

    if (!mobileMedia.matches || !isProductPage() || overlayOpen || currentY < 96 || holdVisible) {
      setNavigationHidden(false);
    } else if (Math.abs(delta) >= 8) {
      setNavigationHidden(delta > 0);
    }

    lastScrollY = currentY;
  };

  const queueScrollVisibility = () => {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(syncScrollVisibility);
  };

  const start = () => {
    syncMobileNavigation();
    syncScrollVisibility();
    document.querySelectorAll('mobile-navigation-bar .cart-count, mobile-navigation-bar .wishlist-count').forEach((badge) => {
      new MutationObserver(syncMobileNavigation).observe(badge, { childList: true, subtree: true, characterData: true });
    });
    window.addEventListener('scroll', queueScrollVisibility, { passive: true });
    window.addEventListener('resize', queueScrollVisibility, { passive: true });
    window.addEventListener('orientationchange', () => {
      setNavigationHidden(false);
      queueScrollVisibility();
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  const initialiseMobileCartPageLink = () => {
    const trigger = document.getElementById('cart-icon-bubble-mobile');
    if (!trigger) return;
    trigger.removeAttribute('aria-haspopup');
    trigger.removeAttribute('aria-controls');
  };

  window.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest('mobile-navigation-bar #cart-icon-bubble-mobile');
    if (!trigger) return;
    event.stopImmediatePropagation();
  }, true);

  initialiseMobileCartPageLink();
  document.addEventListener('shopify:section:load', initialiseMobileCartPageLink);


  

  /* SNUG ADD TO CART STAY PAGE 2026-09-25 START */
  const installStayOnPageCartBehavior = () => {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.open !== 'function' || cart.__snugStayPageInstalled) return;

    const originalOpen = cart.open.bind(cart);
    cart.__snugStayPageInstalled = true;
    cart.__snugOriginalOpen = originalOpen;

    cart.open = (...args) => {
      const recentAddIntent = Date.now() - Number(window.__snugLastAddToCartIntent || 0) < 5000;
      const directUserAction = Boolean(
        args[0]?.source?.matches?.('[data-bundle-add]') === true
        || window.__snugManualCartOpen === true
        || (!recentAddIntent && navigator.userActivation && navigator.userActivation.isActive)
      );

      if (!directUserAction) {
        const drawer = document.querySelector('.minicart__wrapper');
        drawer?.classList.remove('open');
        document.documentElement.classList.remove('open-minicart', 'open-drawer');
        document.body.classList.remove('open-minicart', 'open-drawer');
        setNavigationHidden(false);
        return;
      }

      return originalOpen(...args);
    };
  };

  const markAddToCartIntent = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const form = target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    const addButton = target.closest('[name="add"], .product__add-cart, .bought-together-submit, .product-group-submit, [data-bundle-add]');

    if (!form && !addButton) return;

    /* Keep browsing after AJAX add-to-cart on both mobile and desktop. */
    window.__snugLastAddToCartIntent = Date.now();
    window.__snugLastAddButton = addButton || form?.querySelector('[name="add"], [data-bundle-add]') || target;
    installStayOnPageCartBehavior();
  };

  installStayOnPageCartBehavior();
  document.addEventListener('submit', markAddToCartIntent, true);
  document.addEventListener('click', markAddToCartIntent, true);
  document.addEventListener('shopify:section:load', installStayOnPageCartBehavior);
  /* SNUG ADD TO CART STAY PAGE 2026-09-25 END */

  /* SNUG DESKTOP CART ADDED FEEDBACK 2026-09-25 START */
  const readDesktopCartCount = () => {
    const badge = document.querySelector('#cart-icon-bubble .cart-count');
    if (!badge) return 0;
    const match = (badge.textContent || '').match(/\d+/);
    return match ? Number(match[0]) : 0;
  };

  const animateDesktopAddToCart = () => {
    if (mobileMedia.matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const target = document.getElementById('cart-icon-bubble');
    if (!target) return;

    target.classList.remove('snug-cart-added-pulse');
    void target.offsetWidth;
    target.classList.add('snug-cart-added-pulse');
    window.setTimeout(() => target.classList.remove('snug-cart-added-pulse'), 900);
    showCartAddedToast();

    const source = window.__snugLastAddButton;
    if (!(source instanceof Element) || typeof source.getBoundingClientRect !== 'function') return;
    const from = source.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    const flyer = document.createElement('span');
    flyer.className = 'snug-cart-added-flyer';
    flyer.style.left = `${from.left + from.width / 2 - 14}px`;
    flyer.style.top = `${from.top + from.height / 2 - 14}px`;
    document.body.appendChild(flyer);

    const x = (to.left + to.width / 2) - (from.left + from.width / 2);
    const y = (to.top + to.height / 2) - (from.top + from.height / 2);
    const animation = flyer.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
      { transform: `translate3d(${x * .55}px,${y * .30 - 28}px,0) scale(.82)`, opacity: .92, offset: .58 },
      { transform: `translate3d(${x}px,${y}px,0) scale(.35)`, opacity: 0 }
    ], {
      duration: 720,
      easing: 'cubic-bezier(.2,.75,.25,1)',
      fill: 'forwards'
    });
    animation.onfinish = () => flyer.remove();
  };

  let snugDesktopLastCount = readDesktopCartCount();
  let snugDesktopObserver = null;

  const observeDesktopCartCount = () => {
    const badge = document.querySelector('#cart-icon-bubble .cart-count');
    if (!badge) return;
    snugDesktopObserver?.disconnect();
    snugDesktopObserver = new MutationObserver(() => {
      const nextCount = readDesktopCartCount();
      if (nextCount > snugDesktopLastCount) animateDesktopAddToCart();
      snugDesktopLastCount = nextCount;
      window.setTimeout(observeDesktopCartCount, 0);
    });
    snugDesktopObserver.observe(badge, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  observeDesktopCartCount();
  document.addEventListener('shopify:section:load', observeDesktopCartCount);
  /* SNUG DESKTOP CART ADDED FEEDBACK 2026-09-25 END */

  /* SNUG PET CART GUIDE 2026-09-25 START */
  const readMobileCartCount = () => {
    const badge = document.querySelector('#cart-icon-bubble-mobile .cart-count');
    if (!badge) return 0;
    const match = (badge.textContent || '').trim().match(/^\d+/);
    return match ? Number(match[0]) : 0;
  };

  const positionPetGuideForCart = () => {
    const guide = document.querySelector('.snug-pet-cart-guide');
    const cartLink = document.getElementById('cart-icon-bubble-mobile');
    if (!guide || !cartLink) return;

    const cartRect = cartLink.getBoundingClientRect();
    const dogWidth = 54;
    const startLeft = 12;
    const targetCenter = cartRect.left + (cartRect.width / 2);
    const travel = Math.max(0, targetCenter - startLeft - (dogWidth / 2));
    guide.style.setProperty('--snug-pet-end-x', `${travel}px`);
  };

  let snugLastPetPlay = 0;

  const showCartAddedToast = () => {
    document.querySelectorAll('.snug-cart-added-toast').forEach((node) => node.remove());
    const toast = document.createElement('div');
    toast.className = 'snug-cart-added-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = '✓ Added to cart';
    document.body.appendChild(toast);
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 220);
    }, 1500);
  };

  const revealMobileNavAfterAdd = () => {
    if (!mobileMedia.matches) return;
    snugNavHoldVisibleUntil = Date.now() + 4200;
    setNavigationHidden(false);
    syncMobileNavigation();
    window.clearTimeout(window.__snugNavHoldTimer);
    window.__snugNavHoldTimer = window.setTimeout(() => {
      queueScrollVisibility();
    }, 4300);
  };

  const isPetFriendlyProductPage = () => {
    const path = window.location.pathname;
    return path === '/products/luxeguard-plush-chenille-sofa-cover-waterproof-pet-friendly'
      || path === '/products/luxeguard-plush-chenille-sofa-cover-waterproof-pet-friendly/';
  };

  const playPetCartGuide = () => {
    if (!mobileMedia.matches) return;

    /* Every product gets a clear added-to-cart confirmation. */
    revealMobileNavAfterAdd();

    const cartLink = document.getElementById('cart-icon-bubble-mobile');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reducedMotion) {
      cartLink?.classList.remove('snug-cart-added-pulse');
      void cartLink?.offsetWidth;
      cartLink?.classList.add('snug-cart-added-pulse');
      window.setTimeout(() => cartLink?.classList.remove('snug-cart-added-pulse'), 900);
    }

    showCartAddedToast();

    /* The dog belongs only to the dedicated pet-friendly LuxeGuard product. */
    if (!isPetFriendlyProductPage() || reducedMotion) return;

    const now = Date.now();
    if (now - snugLastPetPlay < 650) return;
    snugLastPetPlay = now;

    const guide = document.querySelector('.snug-pet-cart-guide');
    if (!guide) return;

    positionPetGuideForCart();
    guide.classList.remove('is-running');
    void guide.offsetWidth;
    guide.classList.add('is-running');

    window.clearTimeout(guide.__snugPetTimer);
    guide.__snugPetTimer = window.setTimeout(() => {
      guide.classList.remove('is-running');
    }, 3250);
  };

  let snugLastCartCount = readMobileCartCount();
  let snugPetObserver = null;

  const observeCurrentCartBadge = () => {
    const badge = document.querySelector('#cart-icon-bubble-mobile .cart-count');
    if (!badge) return;

    snugPetObserver?.disconnect();
    snugPetObserver = new MutationObserver(() => {
      const nextCount = readMobileCartCount();
      if (nextCount > snugLastCartCount) playPetCartGuide();
      snugLastCartCount = nextCount;

      /* Shopify may replace the badge node after cart updates. */
      window.setTimeout(observeCurrentCartBadge, 0);
    });

    snugPetObserver.observe(badge, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  const initialisePetCartGuide = () => {
    if (!mobileMedia.matches) return;

    snugLastCartCount = readMobileCartCount();
    observeCurrentCartBadge();
    positionPetGuideForCart();

  };

  initialisePetCartGuide();
  window.addEventListener('snug:cart-added', revealMobileNavAfterAdd);
  document.addEventListener('shopify:section:load', initialisePetCartGuide);
  window.addEventListener('resize', positionPetGuideForCart, { passive: true });
  window.addEventListener('orientationchange', positionPetGuideForCart, { passive: true });

  /* Watch only the small mobile-nav subtree, never the whole page. */
  let snugNavObserver = null;

  const observeMobileNavChanges = () => {
    const mobileNav = document.querySelector('mobile-navigation-bar.mobile-navigation-bar');
    if (!mobileNav) return;

    snugNavObserver?.disconnect();
    snugNavObserver = new MutationObserver(() => {
      const nextCount = readMobileCartCount();
      if (nextCount > snugLastCartCount) playPetCartGuide();
      snugLastCartCount = nextCount;
      observeCurrentCartBadge();
      positionPetGuideForCart();
    });

    snugNavObserver.observe(mobileNav, {
      childList: true,
      subtree: true
    });
  };

  observeMobileNavChanges();
  document.addEventListener('shopify:section:load', observeMobileNavChanges);
  /* SNUG PET CART GUIDE 2026-09-25 END */
})();


(() => {
  const styleId = 'snug-ai-launcher-clearance';
  const launcherStyles = `
    @media (max-width: 768px) {
      #caBubbleWrap {
        left: auto !important;
        right: 16px !important;
        transform: none !important;
        bottom: var(--snug-ai-launcher-bottom, calc(98px + env(safe-area-inset-bottom, 0px))) !important;
        visibility: var(--snug-ai-launcher-visibility, visible) !important;
        pointer-events: var(--snug-ai-launcher-pointer-events, auto) !important;
      }
    }
  `;

  function applyLauncherClearance() {
    const root = document.getElementById('clarity-agents-preview-host')?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = launcherStyles;
      root.appendChild(style);
    }
    return true;
  }

  function watchForLauncher() {
    if (applyLauncherClearance()) return;
    let timeoutId;
    const observer = new MutationObserver(() => {
      if (!applyLauncherClearance()) return;
      observer.disconnect();
      clearTimeout(timeoutId);
    });
    [document.documentElement, document.body].filter(Boolean).forEach((element) => {
      observer.observe(element, { childList: true });
    });
    timeoutId = setTimeout(() => observer.disconnect(), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForLauncher, { once: true });
  } else {
    watchForLauncher();
  }
})();
